<template>
  <img
    v-lazy="$global.imgUrl + column.advertImg"
    class="column-container"
    @click="handleClick"
  />
</template>

<script>
export default {
  props: {
    column: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClick() {
      window.open(this.column.advertLink);
    },
  },
};
</script>

<style lang="scss" scoped>
.column-container {
  width: 395px;
  height: 266px;
  background-color: #ffffff;
  margin-right: 0px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.13);
  cursor: pointer;
  &:not(:last-child) {
    margin-right: 7px;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding: 20px 47px;
  overflow: hidden;
  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }
  .title {
    margin-top: 21px;
    font-size: 18px;
    color: #263d78;
  }
  .content {
    width: 301px;
    margin-top: 17px;
    font-size: 12px;
    color: #333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
}
</style>
